import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioMUI from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import Box from "@mui/material/Box";

function Radio({
  methods,
  label,
  name,
  required,
  items,
  defaultValue,
  inline,
}) {
  const {
    formState: { errors },
    control,
  } = methods;
  const options = items.map((item) => {
    return (
      <FormControlLabel
        key={`${name}${item.value}`}
        value={item.exit ? "__exit" : item.value.toString()}
        control={<RadioMUI />}
        label={<Typography color="textPrimary">{item.label}</Typography>}
      />
    );
  });

  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        defaultValue={defaultValue}
        render={({ field }) => (
          <FormControl
            required={!!required}
            error={errors?.hasOwnProperty(name)}
          >
            <Box
              sx={
                inline
                  ? {
                      display: "flex",
                      alignItems: "center",
                    }
                  : {}
              }
            >
              {label && label !== "" ? (
                <FormLabel
                  required={required}
                  id={`${name}-group-label`}
                  sx={{ marginRight: "15px" }}
                >
                  {label}
                </FormLabel>
              ) : (
                ""
              )}
              <RadioGroup
                {...field}
                row
                aria-labelledby={`${name}-group-label`}
                value={field.value}
              >
                {options}
              </RadioGroup>
            </Box>
            {typeof required === "string" ? (
              <FormHelperText sx={{ marginTop: 0 }}>
                {errors?.hasOwnProperty(name) && errors[name].message
                  ? errors[name].message
                  : " "}
              </FormHelperText>
            ) : null}
          </FormControl>
        )}
      />
    </React.Fragment>
  );
}

Radio.defaultProps = {
  label: "Ma question ?",
  name: "radio",
  required: true,
  items: [
    { label: "Oui", value: 2 },
    { label: "Non", value: 1 },
  ],
  defaultValue: "",
  inline: false,
};

Radio.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Texte à afficher avant le groupe des boutons radio
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Un bouton raido doit-il être coché pour valider le formulaire ?
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * Le label et les radio sur la même ligne
   */
  inline: PropTypes.bool,
  /**
   * Tableau d'objets bouton raido
   * [
   *   { label: 'Oui', value: 2 },
   *   { label: 'Non', exit: true },
   * ]
   */
  items: PropTypes.arrayOf(PropTypes.object),
  /**
   * Valeur du bouton radio coché par défaut
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Fonction exécutée à la validation du formulaire
   */
  submitter: PropTypes.func,
};

export default Radio;
